import api from './config';

export const shiftsAPI = {
  // Obtener todos los turnos
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/shifts', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching shifts:', error);
      throw error;
    }
  },

  // Obtener turno por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/shifts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching shift:', error);
      throw error;
    }
  },

  // Crear nuevo turno
  create: async (shiftData) => {
    try {
      const response = await api.post('/shifts', shiftData);
      return response.data;
    } catch (error) {
      console.error('Error creating shift:', error);
      throw error;
    }
  },

  // Actualizar turno
  update: async (id, shiftData) => {
    try {
      const response = await api.put(`/shifts/${id}`, shiftData);
      return response.data;
    } catch (error) {
      console.error('Error updating shift:', error);
      throw error;
    }
  },

  // Eliminar turno
  delete: async (id) => {
    try {
      const response = await api.delete(`/shifts/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting shift:', error);
      throw error;
    }
  }
};

export default shiftsAPI;
